export class MobileOverflowScroll extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.overflowSectionToScroll = this.querySelector(`${this.dataset.overflowSectionToScroll}`)
    this.stepsToScroll = parseInt(this.dataset.stepsToScroll)
    this.previewArrow = this.querySelector('.js-previous-arrow')
    this.nextArrow = this.querySelector('.js-next-arrow')

    this.previewArrow.addEventListener('click', this.scrollToLeft.bind(this))
    this.nextArrow.addEventListener('click', this.scrollToRight.bind(this))
  }

  disconnectedCallback() {
    this.nextArrow.removeEventListener('click', this.scrollToRight.bind(this))
    this.previewArrow.removeEventListener('click', this.scrollToLeft.bind(this))
  }

  scrollToLeft() {
    this.overflowSectionToScroll.scrollTo({
      left: this.overflowSectionToScroll.scrollLeft - this.stepsToScroll,
      behavior: 'smooth'
    })
  }

  scrollToRight() {
    this.overflowSectionToScroll.scrollTo({
      left: this.overflowSectionToScroll.scrollLeft + this.stepsToScroll,
      behavior: 'smooth'
    })
  }
}

customElements.define('mobile-overflow-scroll', MobileOverflowScroll)
